// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__lbWj-","activeLink":"Header_activeLink__i-OMr"};